import Banner, {BannerTypes} from "patient-ping-remedy/packages/banner";
import React, {Fragment, useEffect} from "react";
import {StyledOptionContainer} from "@manual_encounters/encounter_client_search/ChooseAdmitClient.styles";
import RadioButton from "patient-ping-remedy/packages/radio-button";
import Helpers from "@/helpers/helpers";
import {LabelFormFieldTypography} from "patient-ping-remedy/packages/typography";
import {EncounterClient} from "@/api/dto/encounter";
import ToolTip from "patient-ping-remedy/packages/tool-tip";
import {colors} from "patient-ping-remedy/packages/theme";
import {StyledIcon} from "@clients/profile_page/summary_tab/timeline_components/EncounterDischargeInfo.styles";
import helpers from "@/helpers/helpers";
import {ICONS} from "patient-ping-remedy/packages/icon";

interface AdmitClientChooseProps {
  matchedClients: EncounterClient[],
  type?: string,
  handleChange: (event: (React.ChangeEvent | null), name: string, value: any) => void,
}

const ChooseAdmitClient = ({matchedClients, handleChange, type}: AdmitClientChooseProps) => {
  const firstClientId = matchedClients[0].patientId;
  const hasMatched = matchedClients.length > 1;

  useEffect(() => {
    handleChange(null, 'choosePatient', firstClientId);
  }, [firstClientId]);

  useEffect(() => {
    if(matchedClients.length === 1){
      const createNewButton = document.getElementById(`chosenPatient${firstClientId}`) as HTMLInputElement;
      createNewButton.checked = true;
    }
  }, [matchedClients]);

  function getLabel(client: EncounterClient): string {
    const firstName = Helpers.isDefined(client.firstName) ? client.firstName : '';
    const middleName = Helpers.isDefined(client.middleName) ? client.middleName : '';
    const lastName = Helpers.isDefined(client.lastName) ? client.lastName : '';
    const fullName = firstName + " " + middleName + " " + lastName;
    return `${fullName} (${client.gender}), DOB ${client.dateOfBirth}`;
  }

  return (
    <Fragment>
      {!type && hasMatched &&
        <Banner type={BannerTypes.WARNING}>
          You have previously admitted a similar client. Select an existing client or a new client.
        </Banner>
      }
      {!hasMatched &&
        <LabelFormFieldTypography>No Existing Client Found</LabelFormFieldTypography>
      }
      {matchedClients.map((client: EncounterClient) => {
        const patientId = client.patientId;
        const age = helpers.getAge(client.dateOfBirth!);
        const isMinor = age < 18;
        const label = patientId !== 'NEW' ? getLabel(client) : 'New Client';
        return (
          <StyledOptionContainer key={patientId}>
            <RadioButton
              name={'choosePatient'}
              value={patientId || ""}
              defaultChecked={patientId === firstClientId}
              id={`chosenPatient${patientId}`}
              label={label}
              onChange={(e) => handleChange(e, 'choosePatient', e.target.value)}
            />
            {isMinor && (
              <ToolTip text="Client is under the age of 18" type="dark">
                <span>
                  <StyledIcon
                    iconClass={ICONS['exclamation-triangle']}
                    color={colors.red5}
                    iconSize="2x"
                    weight="fas"
                  />
                </span>
              </ToolTip>
            )}
          </StyledOptionContainer>
        );
      })}
    </Fragment>
  );
};

export default ChooseAdmitClient;
